import { useDocumentTabDataContext } from 'features/knowledgeDocumentViewer/contexts/DocumentTabDataContext'
import { useSearchActions } from 'features/knowledgeDocumentViewer/contexts/SearchActionsContext'
import { useEffect, useRef } from 'react'

export function useAddDocumentToRecents(documentId: string): void {
  const { documentTableRow } = useDocumentTabDataContext()
  const { onAddRecentDocument } = useSearchActions()
  const lastAddedDocId = useRef('')

  useEffect(() => {
    if (!documentTableRow || documentId === lastAddedDocId.current) return
    lastAddedDocId.current = documentId
    onAddRecentDocument(documentTableRow)
  }, [documentId, documentTableRow, onAddRecentDocument])
}
